import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import { messages } from './messages';

const customField2Type = 'CustomFieldTwo';

const Custom2Expanded = ({ fulfillmentPlanId }) => {
  const notes =
    useSelector((state) =>
      Global.selectEntitiesFulfillmentPlanProperty(state, {
        fulfillmentPlanId,
        property: 'notes',
      }),
    ) ?? [];
  const customField2 = notes.find((note) => note.type === customField2Type);

  return customField2?.body ?? '';
};

Custom2Expanded.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export const Custom2 = {
  getMessageDescriptor: () => messages.custom2,
  id: 'custom2',

  render: (data, { isFirstOfType = true } = {}) => {
    if (!data || !isFirstOfType) {
      return '';
    }
    return <Custom2Expanded fulfillmentPlanId={data.id} />;
  },
};
